import { Link } from "react-router-dom";
import Logo from "../Logo";
import * as S from "./styles";

export default function Banner() {
  return (
    <Link to={"/"}>
      <S.StyledBanner>
        <S.BannerText>
        YOUR HOME FOR MADE IN KENYA UNIQUE PIECES TAILORED WITH LOVE
          <br></br>
        </S.BannerText>
        <Logo mode="banner" />
      </S.StyledBanner>
    </Link>
  );
}
